import { NgClass, NgFor, NgIf } from '@angular/common';
import { Component, EventEmitter, forwardRef, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import { ActivityLocationFacade } from '@curbnturf/activity/src/lib/+state/activity.facade';
import { PhoneMaskPipe } from '@curbnturf/cnt-masks';
import { CategorySvgComponent, SiteSvgsComponent } from '@curbnturf/custom-svgs';
import { ActivityLocation, HelperFunctions, IPhoto, User } from '@curbnturf/entities';
import { PhotoDisplayModalComponent } from '@curbnturf/image-processing/src/lib/photo-display-modal/photo-display-modal.component';
import { SaveFavoriteComponent } from '@curbnturf/listing-edit/src/lib/save-favorite/save-favorite.component';
import { IonicModule, LoadingController, ModalController } from '@ionic/angular';
import { LocationMapComponent } from '../location-map/location-map.component';

@Component({
  standalone: true,
  selector: 'curbnturf-activity-location-page',
  templateUrl: './activity-location-page.component.html',
  styleUrls: ['./activity-location-page.component.scss'],
  imports: [
    IonicModule,
    LocationMapComponent,
    NgClass,
    NgFor,
    NgIf,
    PhotoDisplayModalComponent,
    forwardRef(() => SaveFavoriteComponent),
    SiteSvgsComponent,
    CategorySvgComponent,
    PhoneMaskPipe,
  ],
})
export class ActivityLocationPageComponent {
  @Input() activity?: ActivityLocation;
  @Output() closed: EventEmitter<boolean> = new EventEmitter();

  currentPhoto?: IPhoto;
  loaded: boolean = false;
  showAll: boolean = false;
  activitySelected: boolean = false;

  currentUser: User;

  get activityArray(): ActivityLocation[] {
    return this.activity ? [this.activity] : [];
  }

  getPhotoUrl = HelperFunctions.getPhotoUrl3x4Small;
  getLargePhotoUrl = HelperFunctions.getPhotoUrl3x4Large;
  getUserPhotoUrl = HelperFunctions.getPhotoUrlSquareTiny;

  constructor(
    private router: Router,
    private poiFacade: ActivityLocationFacade,
    private modalController: ModalController,
    private loadingCtrl: LoadingController,
  ) {}

  closeModal() {
    this.showAll = false;
    this.closed.emit(true);
  }

  async openPhotoModal() {
    const loading = await this.loadingCtrl.create({
      message: 'Loading Photos...',
    });
    await loading.present();
    const modal = await this.modalController.create({
      component: PhotoDisplayModalComponent,
      cssClass: 'ionic-photo-gallery',
      componentProps: {
        photos: this.activity?.photos?.map((el) => ({
          key: el.key,
          caption: el.caption,
        })),
        siteName: this.activity?.name,
      },
    });
    await loading.dismiss();
    await modal.present();
  }

  async onEditActivity() {
    this.poiFacade.awaitActivity(this.activity);
    await this.router.navigate(['activity', 'edit', this.activity?.id]);
  }
}
